import "./svg/brokkoli.svg"

export default {
    name: "brokkoli",
    viewBox: "124 68",
}
